import { RouteRecordRaw } from 'vue-router';
import { adminRoutes } from '@/routes/adminRoutes.ts';
import { sectionRoutes } from './sectionRoutes/sectionRoutes.ts';
import { deltaGptRoutes } from './deltaGptRoutes.ts';

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/home',
        name: 'Home',
        components: {
            default: () => import('@/views/delta-gpt/LandingPageView.vue'),
        },
        meta: {
            headName: 'Home',
        },
    },
    {
        path: '/',
        redirect: { name: 'Home' },
    },
    ...Object.values(sectionRoutes),
    // Redirect old insights routes to research routes
    {
        path: '/insights/:pathMatch(.*)*',
        redirect: to => ({
            path: to.params.pathMatch
                ? `/research/${Array.isArray(to.params.pathMatch) ? to.params.pathMatch.join('/') : (to.params.pathMatch ?? '')}`
                : '/research',
            query: to.query,
            hash: to.hash,
        }),
    },
    {
        path: '/research',
        name: 'research',
        redirect: { name: 'deltaGptDocumentsList' },
        children: [...Object.values(deltaGptRoutes)],
        meta: {
            headName: 'Research',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    {
        path: '/my-subscriptions',
        name: 'mySubscriptions',
        components: {
            default: () => import('@/views/MyAccessView.vue'),
        },
        meta: {
            headName: 'My Subscriptions',
            requiresLogin: true,
            searchMeta: {
                noSearch: true,
            },
        },
    },
    {
        path: '/chat',
        name: 'chat',
        components: {
            default: () => import('@/views/ChatView.vue'),
        },
        meta: {
            headName: 'Chat',
            requiresLogin: true,
            accessName: 'chat',
            searchMeta: {
                noSearch: true,
            },
        },
    },
    {
        path: '/404',
        name: '404',
        components: {
            default: () => import('@/views/404View.vue'),
        },
        meta: {
            headName: '404',
            searchMeta: {
                noSearch: true,
            },
        },
    },
    {
        path: '/admin',
        name: 'admin',
        redirect: { name: 'usersAdmin' },
        components: {
            default: () => import('@/views/admin/AdminView.vue'),
        },
        meta: {
            headName: 'Admin',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
        children: adminRoutes,
    },
    {
        path: '/terms',
        name: 'Terms',
        components: {
            default: () => import('@/views/TermsView.vue'),
        },
        meta: {
            headName: 'Enact Terms',
            searchMeta: {
                tags: ['terms', 'conditions'],
            },
        },
    },
    {
        path: '/legal/delta-gpt-terms',
        redirect: { name: 'Terms' },
    },
];
